class Ad {

	constructor( node ) {
		this.node = node;
		this.hoverClass = 'shortcode-ad--hover';
		if ('ontouchstart' in window) {
			this.node.addEventListener('touchstart', (e) => {
				if ( this.node.classList.contains(this.hoverClass) && e.target.tagName === 'A' ) {
					return;
				}

				e.preventDefault();
				this.hover();
			});
		}

		this.node.addEventListener('mouseenter', this.hover.bind(this));
		this.node.addEventListener('mouseleave', this.hover.bind(this));
	}

	hover() {
		this.node.classList.toggle(this.hoverClass);
	}

}

export default Ad;
